import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconsInitConfigType } from '../../../constants';
import { IconUIComponent } from '../../atoms/icon/icon.component';

/**
 * What an empty `fr8bot-ui-board-column` shows. Centered over the nearest positioned ancestor, so
 * empty columns line up whatever else they hold (a note, a hint). Place it inside the column's
 * `cdkDropList`: it hides while a card is dragged over that list, where the drop placeholder goes,
 * and lets the pointer through to the list. The check is on the placeholder the CDK puts into the
 * DOM itself, not on `cdk-drop-list-dragging`: that class is a host binding the CDK doesn't
 * refresh when a card enters another list, so it never shows up there in a zoneless app.
 */
@Component({
  selector: 'fr8bot-ui-board-column-empty',
  imports: [IconUIComponent],
  templateUrl: './board-column-empty.component.html',
  host: {
    class:
      'tw:pointer-events-none tw:absolute tw:inset-0 tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-2 tw:text-center tw:text-gray-3 tw:in-[.cdk-drop-list:has(>.cdk-drag-placeholder)]:hidden',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardColumnEmptyUIComponent {
  readonly icon = input.required<IconsInitConfigType>();
  readonly text = input.required<string>();
}
